import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import ReviewAssignModal from './ReviewAssignModal'
import SummaryTable from './SummaryTable'
import auth from './auth';
import { setReviewAssigInfo } from './actions';
import { loadFiles, getDocSummaryOverall } from './thunks';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavDocMain.css';

const NavDocMain = ({ mode, files, userInfo, groupInfo, reviewInfo, startLoadingFiles,
  reviewAssignInfo, startSetReviewAssignInfo, startGetDocSummaryOverall }) => {
  
  let history = useHistory();
  
  const getMyProgressText = () => {
    let pagesAllTotal = 0;
    let pagesAllReviewed = 0;
    let notCancelledFiles = _.filter(files, file => file.statusId !== 2);
    // console.log('>>>1 files:', files);
    // console.log('>>>2 notCancelledFiles:', notCancelledFiles);
    notCancelledFiles.map((file) => pagesAllTotal += parseInt(file.pagesTotal || 0));
    notCancelledFiles.map((file) => pagesAllReviewed += parseInt(file.pagesReviewed || 0));
    let progressPercentage = Math.round(pagesAllReviewed/pagesAllTotal * 100);
    return progressPercentage + ' %';
  };
  
  const getOverallProgressText = () => {
    let summary = reviewInfo.summary || [];
    let progressElement = document.getElementById('nav-overall-progress-dropdown');
    if (progressElement) {
      let allPageCount = 0;
      let reviewedPageCount = 0;
      for (let i = 0; i < summary.length; i++) {
        if (summary[i].status_id !== 2) {
          reviewedPageCount += summary[i].pagesReviewed;
        }
      }
      for (let fileIndex in files) {
        let file = files[fileIndex];
        if (file.statusId !== 2) {
          allPageCount += file.pagesTotal;
        }
      }
      allPageCount = allPageCount * reviewAssignInfo.reviewers.length;
      let progressPercentage = 0;
      if (allPageCount > 0) {
        progressPercentage = Math.round(reviewedPageCount/allPageCount * 100);
      }
      progressElement.innerHTML = 'Overall Progress ' + progressPercentage + '% ';
    }
    return '';
  };
  
  const onOverallDropdownClick = (event) => {
    let params = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      user: reviewInfo.user,
      groupId: reviewInfo.groupId
    };
    startGetDocSummaryOverall(params);
  };
  
  return (
    <div className="AppMain">
      <Navbar bg="viitai" expand="lg">
        <Navbar.Brand>BPS WEB PORTAL</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link>
            { reviewInfo.program } / { reviewInfo.study } / 
            { reviewInfo.milestone } / Group #{ reviewInfo.groupId }
            </Nav.Link>
            <Nav.Link>Due Date { groupInfo.dueDate }</Nav.Link>
            { mode === "review" ?
            <Nav.Link>My Progress { getMyProgressText() }</Nav.Link> : ""
            }
            { userInfo.is_rb && mode === "admin" ?
            <NavDropdown title="Overall Progress" 
              id="nav-overall-progress-dropdown" onClick={onOverallDropdownClick}>
              { getOverallProgressText() }
              <NavDropdown.Item><SummaryTable /></NavDropdown.Item>
            </NavDropdown> : ""
            }
          </Nav>
          <Nav.Link>
          {userInfo.is_rb && mode === "admin" ?
          <img alt="reviewer" src="/images/reviewers.png" onClick={() => {
            startSetReviewAssignInfo({ show:true });
            console.log('review icon clicked');
          }}/>:""
          }
          </Nav.Link>
          <NavDropdown title={reviewInfo.user + ' '} 
            className="nav-dropdown-user" id="collasible-nav-dropdown">
            <NavDropdown.Item 
              onClick={() => {
                auth.signout(() => history.push("/"));
              }}>Logout</NavDropdown.Item>
          </NavDropdown>
        </Navbar.Collapse>
      </Navbar>
      <ReviewAssignModal />
    </div>
  );
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
  reviewAssignInfo: state.reviewAssignInfo,
})

const mapDispatch = dispatch => ({
  startLoadingFiles: (data) => dispatch(loadFiles(data)),
  startSetReviewAssignInfo: (data) => dispatch(setReviewAssigInfo(data)),
  startGetDocSummaryOverall: (data) => dispatch(getDocSummaryOverall(data)),
})

export default connect(mapState, mapDispatch)(NavDocMain);
